<template>
	<div id="subscriptions" class="page">
		<datatable
			model="subscriptions"
			modal="Subscription"
		></datatable>
		<router-view />
	</div>
</template>

<script>
import { mapMutations } from 'vuex'
import Datatable from '../components/Elements/Datatable'

export default {
  name: 'Subscriptions',
  components: {
    Datatable
  },
  data () {
    return {
      //
    }
  },
  computed: {
    //
  },
  methods: {
    ...mapMutations([
      'setPageTitle'
    ])
  },
  created () {
    this.setPageTitle('Subscriptions')
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Subscriptions.vue